import React, { useState, useEffect } from 'react';
import './ThathaPuli.css';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import thatha2 from '../../images/thatha-2.jpg';
import thatha1 from '../../images/thatha-1.jpg';
import thatha6 from '../../images/thatha-6.jpg';
import thatha5 from '../../images/thatha-5.jpg';
import thatha8 from '../../images/thatha-8.jpg';
import thatha7 from '../../images/thatha-7.jpg';
import thatha9 from '../../images/thatha-puli-09.jpg';
import thatha10 from '../../images/thatha-puli-10.jpg';
import thatha13 from '../../images/puli-13.jpg';
import thatha14 from '../../images/puli-14.jpg';

const ThathaPuliPortfolio = () => {
  const [isImageHovered, setIsImageHovered] = useState(false);
  const [isExpressionHovered, setIsExpressionHovered] = useState(false);
  const [isPuliExpressionHovered, setIsPuliExpressionHovered] = useState(false);
  const [isPoseHovered, setIsPoseHovered] = useState(false);
  const [isInteractionHovered, setIsInteractionHovered] = useState(false);
  const [isImageClicked, setIsImageClicked] = useState(false);
  const [isExpressionClicked, setIsExpressionClicked] = useState(false);
  const [isPuliExpressionClicked, setIsPuliExpressionClicked] = useState(false);
  const [isPoseClicked, setIsPoseClicked] = useState(false);
  const [isInteractionClicked, setIsInteractionClicked] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [discoveredImages, setDiscoveredImages] = useState(new Set());
  const [showAchievement, setShowAchievement] = useState(false);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [showCursor, setShowCursor] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleImageDiscover = (imageId) => {
    if (!discoveredImages.has(imageId)) {
      const newDiscovered = new Set(discoveredImages);
      newDiscovered.add(imageId);
      setDiscoveredImages(newDiscovered);
      
      if (newDiscovered.size === 5) {
        setShowAchievement(true);
        setTimeout(() => setShowAchievement(false), 4000);
      }
    }
  };

  const thathaPoses = [
    { icon: '🏃', title: 'Running with motion', desc: 'Dynamic movement with exaggerated lean' },
    { icon: '📰', title: 'Reading newspaper', desc: 'Relaxed sitting, glasses perched on nose' },
    { icon: '☕', title: 'Holding tea', desc: 'Contemplative stance, steam rising' },
    { icon: '🤷', title: 'Questioning gesture', desc: 'Arms outstretched, bewildered expression' },
    { icon: '😰', title: 'Panicked sitting', desc: 'Slouched posture, hands on head' }
  ];

  const interactions = [
    { icon: '🎣', title: 'Fishing together', desc: 'Thatha holds rod, Puli watches water intently' },
    { icon: '🚲', title: 'Cycling duo', desc: 'Puli rides in front basket, wind in fur' },
    { icon: '👴', title: 'Shoulder companion', desc: 'Puli perched on Thatha\'s shoulder' },
    { icon: '🦮', title: 'Leash walking', desc: 'Role reversal: who\'s walking whom?' }
  ];

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      


      {/* Achievement Toast */}
      {showAchievement && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'linear-gradient(135deg, rgba(46, 213, 115, 0.98), rgba(0, 184, 148, 0.98))',
          color: 'white',
          padding: '2.5rem 3.5rem',
          borderRadius: '2rem',
          fontSize: '1.8rem',
          fontWeight: '700',
          zIndex: 2000,
          boxShadow: '0 30px 60px rgba(46, 213, 115, 0.5)',
          animation: 'achievementPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
          backdropFilter: 'blur(20px)',
          border: '3px solid rgba(255, 255, 255, 0.4)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎉</div>
          <div>All Secrets Unlocked!</div>
          <div style={{ fontSize: '1rem', marginTop: '0.5rem', opacity: 0.9 }}>You've discovered all hidden versions</div>
        </div>
      )}

      {/* Custom Cursor Follower */}
      {showCursor && (
        <div style={{
          position: 'fixed',
          left: cursorPos.x,
          top: cursorPos.y,
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          zIndex: 9999,
          transition: 'opacity 0.2s ease'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #f39c12, #e67e22)',
            color: 'white',
            padding: '0.5rem 1rem',
            borderRadius: '1rem',
            fontSize: '0.9rem',
            fontWeight: '600',
            boxShadow: '0 8px 20px rgba(243, 156, 18, 0.4)',
            whiteSpace: 'nowrap',
            animation: 'cursorBounce 0.6s ease-in-out infinite'
          }}>
            ✨ Click to lock!
          </div>
        </div>
      )}

      <div className="thatha-container">
      {/* Animated Background */}
      <div className="thatha-bg-animation">
        <div className="thatha-bg-orb thatha-bg-orb1"></div>
        <div className="thatha-bg-orb thatha-bg-orb2"></div>
        <div className="thatha-bg-orb thatha-bg-orb3"></div>
      </div>

      {/* Header */}
      <header className="thatha-header">
        <div className="thatha-header-content">
          <div className="thatha-badge">CHARACTER DESIGN PORTFOLIO</div>
          <h1 className="thatha-main-title">Thatha & Puli</h1>
          <p className="thatha-subtitle">A Grumpy Old Man and His Mischievous Cat</p>
          <div className="thatha-tags">
            <span className="thatha-tag">🎭 Slice-of-Life</span>
            <span className="thatha-tag">😄 Humor</span>
            <span className="thatha-tag">🇮🇳 South Indian</span>
          </div>
        </div>
      </header>

      <div className="thatha-main-content">
        
        {/* Character Bios */}
        <section className="thatha-section">
          <div className="thatha-section-glow thatha-glow-orange"></div>
          <div className="thatha-section-card">
            <h2 className="thatha-section-title">
              <span className="thatha-title-icon">🧓</span> Character Bios
            </h2>
            <div className="thatha-bio-grid">
              <div className="thatha-bio-card thatha-bio-thatha">
                <div className="thatha-bio-header">
                  <span className="thatha-bio-icon">👴</span>
                  <h3 className="thatha-bio-name">Thatha</h3>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Age:</span>
                  <span className="thatha-bio-value">65</span>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Personality:</span>
                  <span className="thatha-bio-value">Grumpy but lovable, curious, emotionally transparent</span>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Signature Traits:</span>
                  <span className="thatha-bio-value">Oversized boots, receding hairline, expressive mustache, glasses</span>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Backstory:</span>
                  <span className="thatha-bio-value">A retired schoolteacher who spends his days fishing, sipping tea, and arguing with his cat</span>
                </div>
                <div className="thatha-design-notes">
                  <h4>Design Notes:</h4>
                  <ul>
                    <li>Silhouette is rounded and grounded—emphasizing age and weight</li>
                    <li>Boots are exaggerated to symbolize burden and humor</li>
                    <li>Facial expressions range from stern to panicked, enhancing comic timing</li>
                  </ul>
                </div>
              </div>

              <div className="thatha-bio-card thatha-bio-puli">
                <div className="thatha-bio-header">
                  <span className="thatha-bio-icon">🐈</span>
                  <h3 className="thatha-bio-name">Puli (The Cat)</h3>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Species:</span>
                  <span className="thatha-bio-value">Orange tabby with tiger-like stripes</span>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Personality:</span>
                  <span className="thatha-bio-value">Mischievous, expressive, emotionally reactive</span>
                </div>
                <div className="thatha-bio-detail">
                  <span className="thatha-bio-label">Role:</span>
                  <span className="thatha-bio-value">Companion, emotional mirror, comic foil</span>
                </div>
                <div className="thatha-design-notes">
                  <h4>Design Notes:</h4>
                  <ul>
                    <li>Green eyes and bold stripes make Puli visually pop against Thatha's muted palette</li>
                    <li>Expressions range from sly to sad, often reacting to Thatha's moods</li>
                    <li>Poses include sitting, walking, riding in a basket, and being carried—each adding narrative depth</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Character Turnaround */}
        <section className="thatha-section">
          <div className="thatha-section-glow thatha-glow-blue"></div>
          <div className="thatha-section-card">
            <h2 className="thatha-section-title">
              <span className="thatha-title-icon">🔄</span> Character Turnaround
            </h2>
            <p className="thatha-section-desc">Front, side, and back views establishing silhouette, posture, and costume details.</p>
            <div 
              style={{
                position: 'relative', 
                cursor: 'pointer',
                borderRadius: '1rem',
                boxShadow: discoveredImages.has('turnaround') ? '0 0 30px rgba(52, 152, 219, 0.6)' : 'none',
                animation: !discoveredImages.has('turnaround') ? 'imagePulse 2s ease-in-out infinite' : 'none'
              }} 
              onMouseEnter={() => {
                setIsImageHovered(true);
                setShowCursor(true);
              }} 
              onMouseLeave={() => {
                setIsImageHovered(false);
                setShowCursor(false);
              }} 
              onClick={() => {
                setIsImageClicked(!isImageClicked);
                handleImageDiscover('turnaround');
              }}
            >
              <img 
                src={thatha8} 
                alt="Character Turnaround" 
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImageHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImageHovered || isImageClicked) ? 0 : 1}} 
              />
              <img 
                src={thatha7} 
                alt="Character Turnaround" 
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImageHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImageHovered || isImageClicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

        {/* Expression Sheet */}
        <section className="thatha-section">
          <div className="thatha-section-glow thatha-glow-pink"></div>
          <div className="thatha-section-card">
            <h2 className="thatha-section-title">
              <span className="thatha-title-icon">🎭</span> Expression Sheet
            </h2>
            <p className="thatha-section-desc">Distinct facial expressions showcasing emotional range and personality.</p>
            <div 
              style={{
                position: 'relative', 
                cursor: 'pointer',
                borderRadius: '1rem',
                boxShadow: discoveredImages.has('expression') ? '0 0 30px rgba(231, 76, 60, 0.6)' : 'none',
                animation: !discoveredImages.has('expression') ? 'imagePulse 2s ease-in-out infinite' : 'none'
              }} 
              onMouseEnter={() => {
                setIsExpressionHovered(true);
                setShowCursor(true);
              }} 
              onMouseLeave={() => {
                setIsExpressionHovered(false);
                setShowCursor(false);
              }} 
              onClick={() => {
                setIsExpressionClicked(!isExpressionClicked);
                handleImageDiscover('expression');
              }}
            >
              <img 
                src={thatha2} 
                alt="Expression Sheet" 
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isExpressionHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isExpressionHovered || isExpressionClicked) ? 0 : 1}} 
              />
              <img 
                src={thatha1} 
                alt="Expression Sheet" 
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isExpressionHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isExpressionHovered || isExpressionClicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

         {/* Expression Sheet - Puli */}
        <section className="thatha-section">
          <div className="thatha-section-glow thatha-glow-purple"></div>
          <div className="thatha-section-card">
            <h2 className="thatha-section-title">
              <span className="thatha-title-icon">🐾</span> Expression Sheet: Puli
            </h2>
            <p className="thatha-section-desc">6 key expressions showing Puli's emotional reactions and personality.</p>
            <div 
              style={{
                position: 'relative', 
                cursor: 'pointer',
                borderRadius: '1rem',
                boxShadow: discoveredImages.has('puli-expression') ? '0 0 30px rgba(155, 89, 182, 0.6)' : 'none',
                animation: !discoveredImages.has('puli-expression') ? 'imagePulse 2s ease-in-out infinite' : 'none'
              }} 
              onMouseEnter={() => {
                setIsPuliExpressionHovered(true);
                setShowCursor(true);
              }} 
              onMouseLeave={() => {
                setIsPuliExpressionHovered(false);
                setShowCursor(false);
              }} 
              onClick={() => {
                setIsPuliExpressionClicked(!isPuliExpressionClicked);
                handleImageDiscover('puli-expression');
              }}
            >
              <img 
                src={thatha13} 
                alt="Expression Sheet" 
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isPuliExpressionHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isPuliExpressionHovered || isPuliExpressionClicked) ? 0 : 1}} 
              />
              <img 
                src={thatha14} 
                alt="Expression Sheet" 
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isPuliExpressionHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isPuliExpressionHovered || isPuliExpressionClicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

        {/* Pose Sheet */}
        <section className="thatha-section">
          <div className="thatha-section-glow thatha-glow-orange"></div>
          <div className="thatha-section-card">
            <h2 className="thatha-section-title">
              <span className="thatha-title-icon">🏃</span> Pose Sheet
            </h2>
            <p className="thatha-section-desc">Dynamic poses reflecting Thatha's daily rhythm—from quiet mornings to chaotic moments with Puli.</p>
            <div 
              style={{
                position: 'relative', 
                cursor: 'pointer',
                borderRadius: '1rem',
                boxShadow: discoveredImages.has('pose') ? '0 0 30px rgba(243, 156, 18, 0.6)' : 'none',
                animation: !discoveredImages.has('pose') ? 'imagePulse 2s ease-in-out infinite' : 'none'
              }} 
              onMouseEnter={() => {
                setIsPoseHovered(true);
                setShowCursor(true);
              }} 
              onMouseLeave={() => {
                setIsPoseHovered(false);
                setShowCursor(false);
              }} 
              onClick={() => {
                setIsPoseClicked(!isPoseClicked);
                handleImageDiscover('pose');
              }}
            >
              <img 
                src={thatha6} 
                alt="Pose Sheet" 
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isPoseHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isPoseHovered || isPoseClicked) ? 0 : 1}} 
              />
              <img 
                src={thatha5} 
                alt="Pose Sheet" 
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isPoseHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isPoseHovered || isPoseClicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

        {/* Interaction Sheet */}
        <section className="thatha-section">
          <div className="thatha-section-glow thatha-glow-cyan"></div>
          <div className="thatha-section-card">
            <h2 className="thatha-section-title">
              <span className="thatha-title-icon">🧵</span> Interaction Sheet
            </h2>
            <p className="thatha-section-desc">Their bond is visualized through shared activities. Puli's reactions add layers of humor and warmth.</p>
            <div 
              style={{
                position: 'relative', 
                cursor: 'pointer',
                borderRadius: '1rem',
                boxShadow: discoveredImages.has('interaction') ? '0 0 30px rgba(26, 188, 156, 0.6)' : 'none',
                animation: !discoveredImages.has('interaction') ? 'imagePulse 2s ease-in-out infinite' : 'none'
              }} 
              onMouseEnter={() => {
                setIsInteractionHovered(true);
                setShowCursor(true);
              }} 
              onMouseLeave={() => {
                setIsInteractionHovered(false);
                setShowCursor(false);
              }} 
              onClick={() => {
                setIsInteractionClicked(!isInteractionClicked);
                handleImageDiscover('interaction');
              }}
            >
              <img 
                src={thatha9} 
                alt="Interaction Sheet" 
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isInteractionHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isInteractionHovered || isInteractionClicked) ? 0 : 1}} 
              />
              <img 
                src={thatha10} 
                alt="Interaction Sheet" 
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isInteractionHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isInteractionHovered || isInteractionClicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

      </div>

     
      </div>
      <div className="footerOverride">
        <Footer mode={mode} />
      </div>
    </>
  );
};

export default ThathaPuliPortfolio;